import React, { FC } from 'react'

import { Switch } from 'react-router-dom'

import Analyses from 'components_new/pages/Analyses'
import AnalysisTypes from 'components_new/pages/AnalysisTypes'
import AnalysisType from 'components_new/pages/AnalysisType'
import AnalysisTypeAnalyses from 'components_new/pages/AnalysisTypeAnalyses'
import AnalysisTypeSettings from 'components_new/pages/AnalysisTypeSettings'
import Analysis from 'components_new/pages/Analysis'
import Results from 'components_new/pages/Results'

import { useAllowAccessAnalyses } from 'redux/hooks/Permissions'

import AuthRoute from './AuthRoute'

const Routes: FC = () => {
  const isAuthenticated = useAllowAccessAnalyses()

  return (
    <Switch>
      <AuthRoute
        Component={() => <Analysis />}
        isAuthenticated={isAuthenticated}
        path={'/analyses/:id'}
      />
      <AuthRoute
        Component={() => <Analyses />}
        isAuthenticated={isAuthenticated}
        path={'/analyses'}
      />
      <AuthRoute
        Component={() => <AnalysisTypeAnalyses />}
        isAuthenticated={isAuthenticated}
        path={'/analysis-types/:id/analyses'}
      />
      <AuthRoute
        Component={() => <AnalysisTypeSettings />}
        isAuthenticated={isAuthenticated}
        path={'/analysis-types/:id/settings'}
      />
      <AuthRoute
        Component={() => <AnalysisType />}
        isAuthenticated={isAuthenticated}
        path={'/analysis-types/:id'}
      />
      <AuthRoute
        Component={() => <AnalysisTypes />}
        isAuthenticated={isAuthenticated}
        path={'/analysis-types'}
      />
      <AuthRoute
        Component={() => <Results />}
        isAuthenticated={isAuthenticated}
        path={'/results'}
      />
    </Switch>
  )
}

export default Routes
